import { createSelector } from 'reselect'
import {StopGruntLevels, StopOverlayTypes} from "../filterSlice";

const getShowStops = state => state.filter.showStops;
const getStops = state => state.marker.stops;
const getStopOverlay = state => state.filter.stopOverlay;
const getStopLureOnlySpecial = state => state.filter.stopLureOnlySpecial;
const getStopQuestLevel = state => state.filter.stopQuestLevel;
const getStopGruntLevel = state => state.filter.stopGruntLevel;
const getStopShowAll = state => state.filter.stopShowAll;
const getBounds = state => state.map.mapBounds;
const getHidden = state => state.marker.hidden;
const getGiovanni = state => state.marker.giovanni;

export const selectVisibleStops = createSelector(
	[getShowStops, getStops, getStopOverlay, getStopLureOnlySpecial, getStopQuestLevel, getStopGruntLevel, getStopShowAll, getBounds, getHidden, getGiovanni],
	(showStops, stops, overlay, lureOnlySpecial, questLevel, gruntLevel, showAll, bounds, hidden, giovanni) => {
		if( !showStops )
			return [];

		let list = Object.values(stops);

		list = list.filter(data =>
			data.latitude  < bounds[0][0] && data.latitude  > bounds[1][0] &&
			data.longitude < bounds[0][1] && data.longitude > bounds[1][1]
		);

		if( showAll )
			return list;

		const ts = (new Date()).getTime()/1000;
		if( overlay === StopOverlayTypes.NONE ) {
			return []; // If no overlays, and not showAll, show nothing
		} else if( overlay === StopOverlayTypes.GRUNT ) {
			if( gruntLevel === StopGruntLevels.ALL )
				list = list.filter(stop => stop.incident_expiration > gruntLevel);
			else if( gruntLevel === StopGruntLevels.ONLY_GRUNTS )
				list = list.filter(stop => stop.incident_expiration > gruntLevel && stop.incident_grunt_type <= 40);
			else if( gruntLevel === StopGruntLevels.ONLY_LEADERS )
				list = list.filter(stop => stop.incident_expiration > gruntLevel && stop.incident_grunt_type > 40);
			else if( gruntLevel === StopGruntLevels.ONLY_GIOVANNI )
				list = list.filter(stop => stop.incident_expiration > gruntLevel && stop.incident_grunt_type === 44 && giovanni[stop.pokestop_id] === true);
		} else if( overlay === StopOverlayTypes.LURE ) {
			if( lureOnlySpecial )
				list = list.filter(stop => stop.expiration > ts && stop.active_fort_modifier >= 502);
			else
				list = list.filter(stop => stop.expiration > ts);
		} else if( overlay === StopOverlayTypes.QUEST ) {
			list = list.filter(stop => stop.quest && stop.quality >= questLevel); // TODO
		}

		if( Object.entries(hidden).length )
			list = list.filter(stop => !hidden['stop-' + stop.latitude + stop.longitude]);

		return list;
	}
);
